import _styled from "styled-components";
import React from 'react';
import * as styles from "../styles/Body.styles";
export var Body = function Body(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.bodyWrapper
  }, /*#__PURE__*/React.createElement("div", null, children));
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "Body___StyledDiv",
  componentId: "sc-h87z6w-0"
})(["", ""], function (p) {
  return p.$_css;
});